import { Injectable } from '@angular/core';
import { HttpModule, XHRBackend, ConnectionBackend, Http, RequestOptions, RequestOptionsArgs, Request, Response, Headers } from '@angular/http';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { GlobalsService, HelperService, NotifyService } from '../../shared/shared';

export function extendedHttpProviderFactory(backend: XHRBackend, options: RequestOptions, globalsService: GlobalsService, helperService: HelperService, notifyService: NotifyService) {
    return new ExtendedHttp(backend, options, globalsService, helperService, notifyService);
}

@Injectable()
export class ExtendedHttp extends Http {
    constructor(backend: XHRBackend, options: RequestOptions, private globalsService: GlobalsService, private helperService: HelperService, private notifyService: NotifyService) {
        super(backend, options);
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.request(url, options));
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.get(url, options));
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.post(url, body, this.getRequestOptionArgs(options)));
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.put(url, body, this.getRequestOptionArgs(options)));
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.delete(url, options));
    }

    getRequestOptionArgs(options?: RequestOptionsArgs): RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }
        options.headers.append('Content-Type', 'application/json');
        return options;
    }

    private intercept(observable: Observable<Response>): Observable<Response> {
        this.globalsService.beforeRequest.emit("beforeHttpRequestEvent");
        this.globalsService.IsBusy.next(true);

        return observable.do(
            () => {
                return this.globalsService.afterRequest.emit("afterHttpRequestEvent");
            },
            (error) => {
                //this.globalsService.IsBusy.next(false)

                if (this.globalsService.CatchHttpErrorsGlobal)
                    this.notifyService.TME("Fehler", this.helperService.ExtractErrorMessage(error));
            },
            () => {
                //this.globalsService.IsBusy.next(false)
            }
        ).finally(() => {
            this.globalsService.IsBusy.next(false)
        });
    }

    private addDefaultOptions(options?: RequestOptionsArgs): RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }

        return options;
    }
}

export const extendedHttpProvider: any[] = [
    {
        provide: ExtendedHttp,
        deps: [XHRBackend, RequestOptions, GlobalsService, HelperService, NotifyService],
        useFactory: extendedHttpProviderFactory
    }
];


// WEBPACK FOOTER //
// ./src/app/_authentication/http/http.ts